/**
 * Anchor links for sections on `/features`.
 * Shared by the Features page and the header Features menu.
 * `label` is the canonical name: the page heading for that anchor must use it.
 */
export const FEATURES_PAGE_SECTION_LINKS = [
  { hash: '#how-it-works', label: 'How It Works' },
  { hash: '#trading-rules', label: 'Trading Rules' },
  { hash: '#bracket-builder', label: 'Bracket Builder' },
  { hash: '#auto-position-sizing', label: 'Position Sizing' },
  { hash: '#trade-journal', label: 'Trade Journal' },
  { hash: '#liquidity-levels', label: 'Liquidity Overlay' },
  { hash: '#mobile-trading', label: 'Mobile Trading' },
  { hash: '#precision-ai', label: 'PrecisionAI' },
];

/** Hash id without the leading #. Empty when there is no hash. */
export function featuresSectionId(hash) {
  const raw = String(hash || '').replace(/^#/, '');
  if (!raw) return '';
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
